import * as request from './api';

export const getJobsStatistics = (epochStart, epochEnd, options) =>
  request.get(`/getJobsStatistics/${epochStart}/${epochEnd}`, options);
export const getAnnotationCounts = (inspectionType, epochStart, epochEnd, options) =>
  request.get(`/getAnnotationCounts/${inspectionType}/${epochStart}/${epochEnd}`, options);
